import React from 'react';

interface ShareResolveDetailViewProps {
  icon: string;
  name: string;
  typeLabel: string;
  category?: string;
  description?: string;
  children?: React.ReactNode;
}

// The read-only view someone opening a shared link sees, deliberately built out
// of the same markup/classes as the Installed-tab detail page (mt-inst-detail-*)
// rather than a one-off confirm modal — matches what Sanket asked for in
// planning: "a nice view... but only the read format," reusing the real detail
// page instead of inventing a separate look for this one surface.
const ShareResolveDetailView: React.FC<ShareResolveDetailViewProps> = ({ icon, name, typeLabel, category, description, children }) => (
  <div className="mt-inst-detail-page">
    <div className="mt-inst-detail-header">
      <div className="mt-detail-logo">{icon}</div>
      <div className="mt-detail-header__info">
        <div className="mt-detail-title">{name}</div>
        <div className="mt-detail-meta">
          <span className="mt-badge mt-badge--type">{typeLabel}</span>
          {category && (
            <>
              <span className="mt-detail-dot">·</span>
              <span className="mt-detail-dim">{category}</span>
            </>
          )}
        </div>
      </div>
    </div>
    <div className="mt-inst-page-tabs">
      <div className="mt-inst-page-tab mt-inst-page-tab--active">Overview</div>
    </div>
    <div className="mt-inst-tab-content">
      <div className="mt-detail-section">
        {description && <p className="mt-overview-desc">{description}</p>}
        {children}
      </div>
    </div>
  </div>
);

export default ShareResolveDetailView;
